<template>
  <div class="profile-icon flex-column" @click="handleProfileIconClick($event)">
    <span>
      <i
        class="hkfi-hamburger"
        :class="[isLoggedIn ? 'logged-in-user' : 'not-logged-in']"
      ></i>
    </span>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { EVENT_HAMBURGER_IMPRESSION, EVENT_HAMBURGER_OPENED } from "../helpers/analyticsEvents";
import { clientPlatform } from "../config/apiEndpoints";
export default {
  name: "ProfileIcon",

  data() {
    return { clientPlatform };
  },
  mounted() {
    this.$store.dispatch(keyMapsAction.HAMBURGER_ITEMS_API, {});
    if (this.$store.state.Auth.isHamburger) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
        true
      );
      setTimeout(() => {
        this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
      });
    }
    if (clientPlatform == "Web" && LocalStorageFunc.getWebLogin()) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
        true
      );
      LocalStorageFunc.setWebLogin();
    }
    if(this.isLoggedIn) {
      this.$store.dispatch(keyMapsAction.GET_WALLET_BALANCE_DATA, {});
    }
  },
  methods: {
    handleProfileIconClick() {
      if (clientPlatform == "Web") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          true
        );
      } else {
        // document.body.classList.add("body-stop-scroll-mobile");
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          true
        );
      }
      EVENT_HAMBURGER_OPENED({
        userAction: 'hamburger menu open'
      });
      EVENT_HAMBURGER_IMPRESSION()
    },
  },
  computed: {
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    showProfileDrawerModal() {
      return this.$store.state.Auth.showProfileDrawerModal;
    },
  },
};
</script>
